import React, { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { NavLink } from "react-router-dom";
import { CONVERSATION_MODE } from "../../../../../pages/MessagePage/constants";
import { messageActions } from "../../../../../pages/MessagePage/reducer";
import { selectMessage, selectUserId } from "../../../../../util/store/selectors";
import { CHAT_TYPE, MESSAGE_STATUS, operationType } from "../../../../../util/varibles/constants";
import { getLink, LINK_ID, onOpenPage } from "../../../../../util/varibles/global";
import Icon from "../../../../Icon";
import ChatBox from "../../../ChatBox";
import { getSubInfoChatOp, getTitleChatUser } from "../../../constants";
import styles from './style.module.scss';

const Title: React.FC<{ conversation: any }> = ({ conversation }) => {
    const userId = useSelector(selectUserId);
    const { type } = conversation;
    switch (type) {
        case CHAT_TYPE.USER: {
            return getTitleChatUser(conversation, userId);
        }
        case CHAT_TYPE.OPERATION: {
            const { id, operation_type, name: operation_code, tenant_id } = conversation.group_chat;
            const link = getLink[LINK_ID.OP_DETAIL]([tenant_id, id])
            const { icon } = operationType[operation_type] || {}
            return <div className={styles['op-title']}>
                <div className={styles['op-logo']}>
                    <Icon icon={icon!} size='large' />
                </div>
                <NavLink className={styles['op-code']} onMouseDown={(e: any) => onOpenPage(e, link)} to={link}>
                    #{operation_code}
                </NavLink>
                {getSubInfoChatOp(conversation.group_chat)}
            </div>
        }
        default:
            return ''
    }
}

interface IProps {
    id: string
    conversation: any
    mode: CONVERSATION_MODE
}


const Conversation: React.FC<IProps> = (props) => {
    const source = useSelector(selectMessage.messages);
    const { id, mode, conversation } = props;
    const { messages = [], prev: isMore = false, loading = false } = source[id] || {};
    const { status = null } = messages[messages.length - 1] || {};
    const rootRef = useRef<HTMLDivElement>(null);
    const dispatch = useDispatch();
    const isActive = useRef(false);

    useEffect(() => {
        if (rootRef.current && !isActive.current) {
            if (!source[id]) {
                dispatch(messageActions.getMessagesRequest({ id, index: 1 }))
            }
            isActive.current = true;
        }
    }, [dispatch, id, source]);

    useEffect(() => {
        if (mode === CONVERSATION_MODE.OPEN)
            setTimeout(() => {
                const el = document.getElementById('input-' + id);
                if (el)
                    el.focus();
            }, 100);
    }, [id, mode])

    const handleSend = (params: any) => {
        const { type } = props.conversation;
        dispatch(messageActions.sendMessageRequest({ ...params, type, group_id: id }))
    }

    const changeMode = (e: any, mode: CONVERSATION_MODE) => {
        e.preventDefault();
        e.stopPropagation();
        dispatch(messageActions.updateConversations({ conversation, mode }))
        return false
    }

    const close = (e: any) => {
        if (rootRef.current)
            rootRef.current.dataset.mode = 'close';
        setTimeout(() => changeMode(e, CONVERSATION_MODE.CLOSE), 100);
        return false
    }

    return <div
        ref={rootRef}
        className={styles.conversation}
        data-mode={isActive.current ? mode : null}
        data-is-new={status === MESSAGE_STATUS.NEW}
    >
        <div className={styles.title}
            onClick={(e) => changeMode(e, mode === CONVERSATION_MODE.MINIMIZE ? CONVERSATION_MODE.OPEN : CONVERSATION_MODE.MINIMIZE)}>
            <div className={styles['title-name']}><Title conversation={conversation} /></div>
            <div className='bt-close' onMouseDown={close} />
        </div>
        <div className={styles.content}>
            <ChatBox
                data={props.conversation}
                messages={messages}
                loading={loading}
                isMore={isMore}
                onSend={handleSend}
            />
        </div>
    </div>;
};

export default Conversation;
